export enum SessionStorageKey {
  mainBannerClosed = 'main_banner_closed',
}
